import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { VirtualCardTemplateTypes } from 'src/enums'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfigPlusArrayBufferResponseType } from 'src/redux/selectors/axios.selectors'

export const SET_RECEIPT_ATTACHMENT_IDS =
  'app/createVirtualCard/SET_RECEIPT_ATTACHMENT_IDS'
export interface SetReceiptAttachmentIdsAction {
  type: typeof SET_RECEIPT_ATTACHMENT_IDS
  payload: {
    ids: string[]
  }
}
export const createSetReceiptAttachmentIds = (
  ids: string[],
): SetReceiptAttachmentIdsAction => ({
  type: SET_RECEIPT_ATTACHMENT_IDS,
  payload: {
    ids,
  },
})

export const GET_CREDIT_CARD_BULK_TEMPLATE_INIT =
  'app/createVirtualCard/GET_CREDIT_CARD_BULK_TEMPLATE_INIT'
export const GET_CREDIT_CARD_BULK_TEMPLATE_SUCCESS =
  'app/createVirtualCard/GET_CREDIT_CARD_BULK_TEMPLATE_SUCCESS'
export const GET_CREDIT_CARD_BULK_TEMPLATE_FAILURE =
  'app/createVirtualCard/GET_CREDIT_CARD_BULK_TEMPLATE_FAILURE'
export const GET_CREDIT_CARD_BULK_TEMPLATE_TYPE =
  'app/createVirtualCard/GET_CREDIT_CARD_BULK_TEMPLATE_TYPE'

export type GetCreditCardBulkTemplateSuccessPayload = string

export interface GetCreditCardBulkTemplateInitAction {
  type: typeof GET_CREDIT_CARD_BULK_TEMPLATE_INIT
}
export interface GetCreditCardBulkTemplateSuccessAction {
  type: typeof GET_CREDIT_CARD_BULK_TEMPLATE_SUCCESS
  payload: GetCreditCardBulkTemplateSuccessPayload
  templateType: string
}
export interface GetCreditCardBulkTemplateFailureAction {
  type: typeof GET_CREDIT_CARD_BULK_TEMPLATE_FAILURE
  payload: unknown
}

export type GetCreditCardBulkTemplateActions =
  | GetCreditCardBulkTemplateInitAction
  | GetCreditCardBulkTemplateSuccessAction
  | GetCreditCardBulkTemplateFailureAction

const createGetCreditCardBulkTemplateInitAction =
  (): GetCreditCardBulkTemplateInitAction => ({
    type: GET_CREDIT_CARD_BULK_TEMPLATE_INIT,
  })
const createGetCreditCardBulkTemplateSuccessAction = (
  payload: GetCreditCardBulkTemplateSuccessPayload,
  templateType: string,
): GetCreditCardBulkTemplateSuccessAction => ({
  type: GET_CREDIT_CARD_BULK_TEMPLATE_SUCCESS,
  payload,
  templateType: templateType,
})
const createGetCreditCardBulkTemplateFailureAction = (
  response: unknown,
): GetCreditCardBulkTemplateFailureAction => ({
  type: GET_CREDIT_CARD_BULK_TEMPLATE_FAILURE,
  payload: response,
})

export const getCreditCardBulkTemplate = (
  type?: string,
): ThunkAction<
  Promise<
    | GetCreditCardBulkTemplateSuccessAction
    | GetCreditCardBulkTemplateFailureAction
  >,
  RootState,
  void,
  GetCreditCardBulkTemplateActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetCreditCardBulkTemplateActions>,
    getState: () => RootState,
  ): Promise<
    | GetCreditCardBulkTemplateSuccessAction
    | GetCreditCardBulkTemplateFailureAction
  > => {
    dispatch(createGetCreditCardBulkTemplateInitAction())
    return axios
      .get<GetCreditCardBulkTemplateSuccessPayload>(
        `/bulkvirtualcarduploads/bulkvirtualcardtemplate?type=${type}`,
        selectAuthedJsonApiRequestConfigPlusArrayBufferResponseType(getState()),
      )
      .then(
        async (response) => {
          return dispatch(
            createGetCreditCardBulkTemplateSuccessAction(
              response.data,
              type || VirtualCardTemplateTypes.Standard,
            ),
          )
        },
        async (err) => {
          return dispatch(
            createGetCreditCardBulkTemplateFailureAction(err.response.data),
          )
        },
      )
  }
}
